import { useCallback, useEffect, useState } from 'react';
import { NganHang, NganHangResponse } from '@/types/schemas';
import { useAuth } from '@/contexts/auth-context';
import { QUERY_KEYS } from '@/constants';
import api from '@/lib/api';

export interface UseNganHangReturn {
  nganHangs: NganHang[];
  isLoading: boolean;
  error: string | null;
  fetchNganHangs: () => Promise<void>;
  refreshNganHangs: () => Promise<void>;
}

export const useNganHang = (initialNganHangs: NganHang[] = []): UseNganHangReturn => {
  const [nganHangs, setNganHangs] = useState<NganHang[]>(initialNganHangs);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const { entity } = useAuth();

  const fetchNganHangs = useCallback(async () => {
    if (!entity?.slug) return;

    setIsLoading(true);
    setError(null);
    try {
      const response = await api.get<NganHangResponse>(`/entities/${entity.slug}/erp/${QUERY_KEYS.NGAN_HANG}/`);
      setNganHangs(response.data.results as unknown as NganHang[]);
    } catch (error) {
      console.error('Error fetching banks:', error);
      setError('Có lỗi xảy ra khi tải dữ liệu ngân hàng');
    } finally {
      setIsLoading(false);
    }
  }, [entity?.slug]);

  const refreshNganHangs = useCallback(async () => {
    await fetchNganHangs();
  }, [fetchNganHangs]);

  useEffect(() => {
    fetchNganHangs();
  }, [fetchNganHangs]);

  return {
    nganHangs,
    isLoading,
    error,
    fetchNganHangs,
    refreshNganHangs
  };
};
